// extracted by mini-css-extract-plugin
export default {"infoContainer":"AdditionalInfo_infoContainer__vLA+T","actor":"AdditionalInfo_actor__RtJOb"};